import { createOpenThread, createSharedResource, threadId } from '../../client/chat/common/store';
import type { ChatPreview, KanzleiUnread } from '../../client/chat/common/types';

// Ungelesene Mandanten-Nachrichten für den angemeldeten Mitarbeiter, gemeinsam für Leiste, Zähler und Meldungen.
export const kanzleiChat = createSharedResource<KanzleiUnread>('/api/kanzlei/chat/unread');
export const kanzleiOpenThread = createOpenThread();

export interface UnreadRow {
  clientId: string;
  clientName: string;
  contactName: string;
  unread: number;
  // Chat mit der neuesten ungelesenen Nachricht
  staffId: string;
  staffName: string;
  own: boolean;
  latest: ChatPreview | null;
}

// Eine Zeile je Mandant mit Ungelesenem. Der gerade offene Chat zählt nicht.
export function unreadRows(data: KanzleiUnread | undefined, open: string | null): UnreadRow[] {
  const rows: UnreadRow[] = [];
  for (const c of data?.clients ?? []) {
    const threads = c.threads.filter((t) => t.unread > 0 && threadId(c.clientId, t.staffId) !== open);
    if (!threads.length) continue;
    const top = threads.reduce((a, t) => ((t.latest?.at ?? '') > (a.latest?.at ?? '') ? t : a));
    rows.push({
      clientId: c.clientId,
      clientName: c.clientName,
      contactName: c.contactName,
      unread: threads.reduce((n, t) => n + t.unread, 0),
      staffId: top.staffId,
      staffName: top.staffName,
      own: top.own,
      latest: top.latest,
    });
  }
  return rows;
}

export const chatTabPath = (clientId: string, staffId?: string) =>
  `/kanzlei/mandanten/${clientId}/chat${staffId ? `?mit=${staffId}` : ''}`;
